<template>
  <v-container class="pa-0 about-page">
    <div v-html="content.text2" class="content-highlight aqua--text"></div>

    <div v-html="content.text1"></div>
    <div class="pb-8 pt-4">
      <v-img
        height="360"
        position="center center"
        src="@/assets/images/entrypages/1074868_2.jpg"
      ></v-img>
    </div>
    <div v-html="content.text4" class="content-highlight aqua--text"></div>

    <div v-html="content.text3"></div>
  </v-container>
</template>

<script>
export default {
  name: 'Home',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
